import { render, staticRenderFns } from "./bomFabirc.vue?vue&type=template&id=dc438a4a&"
import script from "./bomFabirc.vue?vue&type=script&lang=js&"
export * from "./bomFabirc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc438a4a')) {
      api.createRecord('dc438a4a', component.options)
    } else {
      api.reload('dc438a4a', component.options)
    }
    module.hot.accept("./bomFabirc.vue?vue&type=template&id=dc438a4a&", function () {
      api.rerender('dc438a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mes/components/productionProgress/bomFabirc.vue"
export default component.exports